const getNodeUrl = () => {

  /* return 'https://polygon-rpc.com/' */
  /* return 'https://rpc.ftm.tools/' */
  return 'https://rpc-mainnet-cardano-evm.c1.milkomeda.com '
}

export default getNodeUrl
